import React, { Component } from "react";
import PropTypes from "prop-types";
import NotFound from "../NotFound";
import InfiniteScroll from "react-infinite-scroller";
import { Loader } from "semantic-ui-react";

class PostsList extends Component {
  constructor(props) {
    super(props);
    this.loadMorePosts = this.loadMorePosts.bind(this);
  }
  loadMorePosts() {
    let { pagingToken } = this.props.posts;
    this.props.loadMorePosts({
      override: false,
      pagingToken,
    });
  }

  getPostImages(post) {
    let coverImageIndex = 0;
    const images = post.images.map((image, index) => {
      if (image.isCover) {
        coverImageIndex = index;
      }
      return { ...image, src: image.url };
    });

    return {
      images,
      coverImageIndex,
    };
  }

  render() {
    const { hasMore = true, data: posts = [] } = this.props.posts;
    const { CaseListComponent, NotFoundComponent } = this.props;
    if (posts.length === 0 && !hasMore) {
      if (NotFoundComponent) {
        return NotFoundComponent;
      }
      return <NotFound msg="No Posts Found" />;
    }

    //Props to be passed to the child component
    const caseListProps = {
      posts,
      getPostImages: this.getPostImages,
    };

    return (
      <div className="PostsList">
        <InfiniteScroll
          loadMore={this.loadMorePosts}
          hasMore={hasMore}
          loader={
            <div className="padded">
              <Loader size="large" active inline="centered" />
            </div>
          }
        >
          <CaseListComponent {...caseListProps} />
        </InfiniteScroll>
      </div>
    );
  }
}

PostsList.propTypes = {
  posts: PropTypes.object.isRequired,
  loadMorePosts: PropTypes.func.isRequired,
};

export default PostsList;



// WEBPACK FOOTER //
// ./src/components/PostsList/index.js